import { type Locale } from 'invictus-sdk-typescript'

export const DEFAULT_LOCALE: Locale = 'fr'

// This record should contain all locales. Record type makes it break if a locale is missing
const allLocalesRecord: Record<Locale, true> = {
  fr: true,
  es: true,
  en: true,
  de: true,
  it: true,
}

export const allLocales = Object.keys(allLocalesRecord) as Locale[]
